import { useEffect, useState } from "react"
import { useFormState } from "react-hook-form"

export const useGetChangedFields = (control:any,watch:any,fieldsJson:any,getValues:any,initialValues:any) =>{

    const [changedFields,setChangedFields] = useState({})
    const { dirtyFields } = useFormState({ control })

  const watchAllFields = watch()

  const temp = Object.keys(dirtyFields).reduce((acc:any, key:any) => {
    const fieldName = fieldsJson?.find((item: { name: any })=>item.name==key)?.label ?? ''
    acc.push({id:key,field:fieldName.replace('*', ''),newData:getValues(key),oldData:initialValues[key]});
    return acc;
  }, [])

  useEffect(()=>{
    setChangedFields(temp)
  },[watchAllFields])

  return changedFields

} 